import React from 'react';

const ColorPicker = ({
  value,
  onChange,
  label,
  placeholder = '#000000',
  presetColors = [
    { color: '#3b82f6', name: 'blue' },
    { color: '#ef4444', name: 'red' },
    { color: '#10b981', name: 'green' },
    { color: '#f59e0b', name: 'orange' },
    { color: '#8b5cf6', name: 'purple' },
    { color: '#06b6d4', name: 'cyan' },
    { color: '#ffff00', name: 'yellow' },
    { color: '#ec4899', name: 'pink' },
    { color: '#00ffff', name: 'aqua' },
    { color: '#6b7280', name: 'gray' },
    { color: '#000000', name: 'black' },
    { color: '#ffffff', name: 'white' },
    { color: '#ff6b6b', name: 'lightcoral' },
    { color: '#4ecdc4', name: 'mediumturquoise' },
    { color: '#ffe66d', name: 'khaki' },
  ],
}) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-slate-400 mb-3">
        {label}
      </label>

      <div className="space-y-4">
        <div className="grid grid-cols-5 gap-3">
          {presetColors.map((colorObj) => (
            <button
              key={colorObj.name}
              type="button"
              className={`w-10 h-10 rounded-full border-2 transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 border-gray-400 dark:border-gray-500 ${
                value === colorObj.color || value === colorObj.name
                  ? 'border-gray-900 dark:border-white scale-110 shadow-lg border-3'
                  : 'shadow-sm'
              }`}
              style={{ backgroundColor: colorObj.color }}
              onClick={() => onChange(colorObj.name)}
              title={`${colorObj.name}`}
            />
          ))}
        </div>

        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <input
              value={value}
              onChange={(e) => onChange(e.target.value)}
              type="color"
              className="h-10 w-12 rounded border-2 border-gray-400 dark:border-gray-500 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-sm"
            />
            <span className="text-sm text-gray-600 dark:text-slate-400 font-medium">
              Custom
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorPicker;
